import Tracker from "@openreplay/tracker";

const analyticsTracker = new Tracker({
  projectKey: process.env.REACT_APP_ANALYTICS_KEY,
  ingestPoint: "https://analytics.leadvent.com/ingest"
});

export { analyticsTracker };
